import React from 'react';
import './Methodology.css';

const Methodology = () => {
  const pillars = [
    {
      title: 'On-Time',
      description: 'Explicit planning with phased roadmaps, controlled rollouts, and defined milestones ensure predictable delivery.',
      icon: '⏱️'
    },
    {
      title: 'On-Budget',
      description: 'Transparent scope and pricing with no hidden costs. We align expectations before work begins.',
      icon: '💰'
    },
    {
      title: 'On-Quality',
      description: 'Tested, documented outcomes meeting acceptance criteria. SOPs, training, and post-implementation monitoring ensure sustained success.',
      icon: '✓'
    }
  ];

  return (
    <section className="methodology" id="about">
      <div className="methodology-container">
        <div className="methodology-split">
          <div className="methodology-left">
            <h2 className="methodology-title">Our Methodology: Pillars of Success</h2>
            <p className="methodology-description">
              We deliver on-time, on-budget, on-quality outcomes through a proven methodology
              that emphasizes discovery, planning, testing, and continuous improvement.
            </p>
            
            <div className="pillars-list">
              {pillars.map((pillar, index) => (
                <div key={index} className="pillar-item">
                  <h3 className="pillar-title">{pillar.title}</h3>
                  <p className="pillar-description">{pillar.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="methodology-right">
            <img 
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80" 
              alt="Team collaboration" 
              className="methodology-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Methodology;
